/**
 * @title rxaddresshelper.js: Sub-module for Rx pages
 * @description This module is used to handle address operations
 * @dependency 
 */
define(['address', 'addressVerification', 'membershipHelper'], function(address, addressVerification, membershipHelper) {

  var QuickRenewAddressHelper = {

    addressArrayForAVS: [],
    init : function() {
    	
    },

    /**
     * URL JSON object with manage address URL constants
     * @type {Object}
     */
    url: {
      MANAGE_ADDRESS_ADD: 'AjaxQuickRenewManageAddressCmd'
    },
    
    submitAddress : function(addressAddedSuccessCallback, taxChangedCallback) {

      if (QuickRenewAddressHelper.isShippingBillingAddressValid()) {
        addressArrayForAVS = QuickRenewAddressHelper.buildAVSAddressArray();

        let avsSuccessCallback = function(addressObjArray) {
          membershipHelper.invokeMultiAVS(addressObjArray, function(choosenAddresses) {
            QuickRenewAddressHelper.ajaxSubmitAddress(choosenAddresses, addressObjArray, addressAddedSuccessCallback, taxChangedCallback);          
          });
        }

        let avsOptions = {
          successCallback : avsSuccessCallback
        };
        
        addressVerification.addressVerification(addressArrayForAVS, undefined, true, avsOptions);       
      }

    },    

    ajaxSubmitAddress : function(addressArrayObj, originalAddress, callback) {

      let form = $('#quick-renew-address-form');
      QuickRenewAddressHelper.populateAddressData(form, addressArrayObj);

      let addressData = QuickRenewAddressHelper.alterAddressObjectWithAVSResult(addressArrayObj, originalAddress);

	  let isWallet = $("input[name='walletCheckout']").val() == 'true' || ($('#radio-visa').length > 0 && $('#radio-visa')[0].checked)
			           || ($('#radio-master').length > 0 && $('#radio-master')[0].checked)
	  let options = {
        url: QuickRenewAddressHelper.url.MANAGE_ADDRESS_ADD,
        method: "POST",
        dataType: 'json',
        data: {
          'authToken': COSTCO.Checkout.getAuthToken(),
          formdata: encodeURIComponent(JSON.stringify(addressData)),
          wallet: isWallet
        },
        ajax_update_post_done: function(data) {
          let application = data.error.application;
          if (application.length == 0) {
            $('body').trigger("costco.address.added", data.payload.data[1]);

            let responseData = data.payload.data;
            let taxChanged = (responseData && responseData.taxChanged) ? true : false;
            let refreshTokenGateway = (responseData && responseData.refreshTokenGateway) ? true : false;

            callback(taxChanged, refreshTokenGateway);

          } else {
            $('body').trigger("costco.address.error", application);
          }

        },
        ajax_handle_errors: function(response_obj, mergedOptions, defaultOptions) {
          if ($('#isBDAppVar').val() == 'BD') {
            $('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
          }
          let error_container = mergedOptions.error_container;
          let input_container = mergedOptions.input_container;
          let application = response_obj.error.application || [];
          let exception = response_obj.error.exception || [];
          let error_html = '';
          if (exception.length > 0) {
            error_html += '<p>An unexpected error has occured</p>';
          }
          application.forEach(function(error_message) {
          	error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
          });
          // if there is a redirect, store the error in sessionStorage and redirect user,
          // otherwise error will show in error container
          if (response_obj.error.redirect) {
            if (typeof sessionStorage != 'undefined') {
              sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
            }
            document.location.href = '/' + response_obj.error.redirect;
            return;
          }
          if (typeof(error_container) === 'string') {
            error_container = $(error_container);
          }
          if (input_container) {
            if ((application.length + exception.length) > 0) {
              $(input_container).addClass('error');
              $(input_container).attr('aria-invalid', 'true');
            } else {
              $(input_container).removeClass('error');
              $(input_container).attr('aria-invalid', 'false');
            }
          }
          if (error_container == '' || error_container.length == 0) {
            $('body').trigger('costco.ajax.content.update.sucess', response_obj);
            return;
          }
          error_container.children().remove();
          error_container.append(error_html);
          if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
            $('body').trigger('costco.ajax.content.update.error', response_obj);
            $('body, html').animate({
              scrollTop: $(error_container).offset().top - 30,
            }, 800);
          }
        }
      }

      COSTCO.Checkout.ajax_update_state(options);
    },

    /**
     * Return true if AVS fields changed
     */
    isAddressChanged : function() {
    	let currentAddressArrayForAVS = QuickRenewAddressHelper.buildAVSAddressArray();
    	if(addressArrayForAVS.length != currentAddressArrayForAVS.length)
    		return true;
    	
    	let addressChanged = false;
    	for(var i = 0; i < addressArrayForAVS.length; i++) {
    		if(addressArrayForAVS[i].fName.trim() != currentAddressArrayForAVS[i].fName.trim() || 
				addressArrayForAVS[i].lName.trim() != currentAddressArrayForAVS[i].lName.trim() ||
				addressArrayForAVS[i].company.trim() != currentAddressArrayForAVS[i].company.trim() ||
				addressArrayForAVS[i].line1.trim() != currentAddressArrayForAVS[i].line1.trim() ||
				addressArrayForAVS[i].line2.trim() != currentAddressArrayForAVS[i].line2.trim() ||
				(addressArrayForAVS[i].city != null && addressArrayForAVS[i].city.trim() != currentAddressArrayForAVS[i].city.trim()) ||
				(addressArrayForAVS[i].state != null && addressArrayForAVS[i].state.trim() != currentAddressArrayForAVS[i].state.trim() ) ||
				addressArrayForAVS[i].zip.trim() != currentAddressArrayForAVS[i].zip.trim() ||
				addressArrayForAVS[i].country.trim() != currentAddressArrayForAVS[i].country.trim() ||
				addressArrayForAVS[i].email.trim() != currentAddressArrayForAVS[i].email.trim()) {
    			addressChanged = true;
    			break;
    		}
    	}
    	addressChanged = addressChanged || $('#shipping_set_default').prop('checked') === true || $('#billing_set_default').prop('checked') === true;
    	return addressChanged;
    },
    
    /**
     * Checks whether populated address is default one
     */
    isDefaultAddress : function(addressType) {
    	let addressTypePrefix = 'shipping_';
        if (addressType === 'B') {
          addressTypePrefix = 'billing_';
        }
    	let defaultAddress = false;
    	let addressId = $('#' + addressTypePrefix + 'addressId').val();
    	if(typeof addressId !== 'undefined' && addressId.length > 0) {
    		defaultAddress = (window['ajaxAddressObject_' + addressId].isPrimary === true);
    	}
    	return defaultAddress;
    },

    /**
     * Jquery validator implementation for shipping/billing form data, specific for renew membership address form
     */
    isShippingBillingAddressValid : function() {
    	COSTCO.CAddressForm.validationRules();
    	let form = $('#quick-renew-address-form');
    	let isValid = true;
		if (form.length != 0) {
			let differentBillingAddress = $('#use-different-address-for-billing').val() == 'true';
			form.validate({
				focusInvalid : false,
				invalidHandler : COSTCO.util.invalid_handler,
				rules : {
					shipping_firstModal : {required: true, firstNameValidation: true},
					shipping_lastModal : {required: true, lastNameValidation: true},
					shipping_country : "required",
					shipping_address1 : {required: true, maxlength: 30, pobox: true},
					shipping_address2 : {maxlength: 30},
					shipping_company : {maxlength: 40,companyrequiredcheck:true},
					shipping_postal : {required: true, countryspecificpostalcodePassCountrySelectorModal:true},
					shipping_city : "required",
					shipping_state : {required: true, notEqual:"NO_STATE_TYPE_SELECTED", hasvalidationerror: true},
					shipping_phone : {required: true, phone:true},
					shipping_email : {required: true, email: true},
					shipping_contactName  : "required",
					shipping_contactPhone : "phone",
					shipping_ext1 : "digits",
					billing_firstModal : {required:true && differentBillingAddress, firstNameValidation: true},
					billing_lastModal : {required:true && differentBillingAddress, lastNameValidation: true},
					billing_country : differentBillingAddress ? "required" : "",
					billing_address1 : {required: true && differentBillingAddress, maxlength: 30, pobox: true},
					billing_address2 : {maxlength: 30},
					billing_company : {maxlength: 40,companyrequiredcheck:true},
					billing_postal : {required:true && differentBillingAddress, countryspecificpostalcodePassCountrySelectorModal:true},
					billing_city : differentBillingAddress ? "required" : "",
					billing_state : {required: true && differentBillingAddress, notEqual:"NO_STATE_TYPE_SELECTED", hasvalidationerror: true},
					billing_phone : {required: true && differentBillingAddress, phone:true},
					billing_email : {required: true && differentBillingAddress, email: true},
					billing_contactName  : differentBillingAddress ? "required" : "",
					billing_contactPhone : "phone",
					billing_ext1 : "digits"
				},
				messages : {
					shipping_firstModal : {required:messages.ERR_INVALID_FIRSTNAME},
					shipping_lastModal : {required:messages.ERR_INVALID_LASTNAME},
					shipping_country : messages.ERR_INVALID_COUNTRY,
					shipping_address1 : {required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX},
					shipping_address2 : {maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH},
					shipping_company : {maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH,companyrequiredcheck: messages.ERR_INVALID_COMPANY},
					shipping_postal : messages.ERR_ENTER_ZIPCODE,
					shipping_city : messages.ERR_INVALID_CITY,
					shipping_state : messages.ERR_INVALID_STATE,
					shipping_phone : {required:messages.ERR_INVALID_PHONE1,phone:messages.ERR_INVALID_PHONE1},
					shipping_email : {required:messages.ERR_REQUIRED_EMAIL_MY, email:messages.ERR_INVALID_EMAIL},
					shipping_contactName : messages.ERR_INVALID_CONTACT_NAME,
					shipping_contactPhone : messages.ERR_INVALID_PHONE1,
					shipping_ext1: messages.ERR_INVALID_EXTN_NUMBER,
					billing_firstModal : {required:messages.ERR_INVALID_FIRSTNAME},
					billing_lastModal : {required:messages.ERR_INVALID_LASTNAME},
					billing_country : messages.ERR_INVALID_COUNTRY,
					billing_address1 : {required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX},
					billing_address2 : {maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH},
					billing_company : {maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH,companyrequiredcheck: messages.ERR_INVALID_COMPANY},
					billing_postal : messages.ERR_ENTER_ZIPCODE,
					billing_city : messages.ERR_INVALID_CITY,
					billing_state : messages.ERR_INVALID_STATE,
					billing_phone : {required:messages.ERR_INVALID_PHONE1,phone:messages.ERR_INVALID_PHONE1},
					billing_email : {required:messages.ERR_REQUIRED_EMAIL_MY, email:messages.ERR_INVALID_EMAIL},
					billing_contactName : messages.ERR_INVALID_CONTACT_NAME,
					billing_contactPhone : messages.ERR_INVALID_PHONE1,
					billing_ext1: messages.ERR_INVALID_EXTN_NUMBER
				},
				errorPlacement : function(error, element) {
					if (element.attr("name") == "shipping_state" ) {
						element.parent().addClass('error');
			      		error.insertAfter($('[name=shipping_state]').parent());
			    	} else if (element.attr("name") == "shipping_country" ) {
						element.parent().addClass('error');
			      		error.insertAfter($('[name=shipping_country]').parent());
			    	} else if (differentBillingAddress && element.attr("name") == "billing_state" ) {
						element.parent().addClass('error');
			      		error.insertAfter($('[name=billing_state]').parent());
			    	} else if (differentBillingAddress && element.attr("name") == "billing_country" ) {
						element.parent().addClass('error');
			      		error.insertAfter($('[name=billing_country]').parent());
			    	} else{
			      		error.insertAfter(element);
			    	}
			  	}
			})



			var selectsValid = true;

			form.find('.style-select > select').each(function() {
				$(this).unbind('change').change(function(){
					if($(this).val()==="NO_STATE_TYPE_SELECTED"){
						selectsValid=false;
						$(this).parent().addClass('error');
					}else{
						$(this).parent().removeClass('error');
						if($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null){
							$(this).attr('hasvalidationerror', false);
						}
					}
				})
			});


			form.find('.style-select > select').change();

			isValid = (form.valid() && selectsValid);
		}
		return isValid;
    },

    /**
     * Use user selected address details (after AVS result is displayed to the user to choose an address),
     * and alter original address obj that will be sent to 'address add' service with choosen values.
     */
    alterAddressObjectWithAVSResult : function(choosenAddresses, originalAddresses) {

      $.each(originalAddresses.Address, function (index, value) {
        originalAddresses.Address[index].line1 = choosenAddresses[index].line1;
        originalAddresses.Address[index].line2 = choosenAddresses[index].line2;
        originalAddresses.Address[index].city = choosenAddresses[index].city;
        originalAddresses.Address[index].state = choosenAddresses[index].state;
        originalAddresses.Address[index].zip = choosenAddresses[index].zip;
        originalAddresses.Address[index].country = choosenAddresses[index].country;
      });

      let finalAddressArray = {};
      if (originalAddresses.Address.length > 0) {
        finalAddressArray = QuickRenewAddressHelper.transormAddressObj(originalAddresses.Address[0]);
      }

      if (originalAddresses.Address.length == 2) {
        let bTransformedAddy = QuickRenewAddressHelper.transormAddressObj(originalAddresses.Address[1]);
        finalAddressArray =  $.extend(finalAddressArray , bTransformedAddy);
      }

      return finalAddressArray;
    },

    /**
     * This function populates a given form. Its meant to replace the values
     * of each designated field with what the addresses selected after the
     * verification process. We then can just serialize the form to send to the
     * backend.
     * @param  {jQuery} form        The form to populate
     * @param  {Array} addresses    Array of validated addresses to get address
     *                              details from it and send with membership
     *                              application form.
     * @param  {boolean} isAffiliate Are we populating the affiliate form?
     * @return {void}
     */
    populateAddressData: function(form, addresses) {

      if (addresses.length > 0) {
        let shippingAddress = addresses[0];
        let prefix = 'shipping_';
        QuickRenewAddressHelper.populateAddressFormElement(form, shippingAddress, prefix);

        if (addresses.length > 1) {
          let billingAddress = addresses[1];
          let prefix = 'billing_';   
          QuickRenewAddressHelper.populateAddressFormElement(form, billingAddress, prefix);
        }
      }
      
    },

    /**
     * Populate etither shipping or billing form inputs with what user has choosen after AVS suggestion
     */
    populateAddressFormElement: function(form, address, prefix) {
      form.find(`input[name=${prefix}address1],input[name=${prefix}line1]`).val(address.line1);
      form.find(`input[name=${prefix}address2],input[name=${prefix}line2]`).val(address.line2);
      
      var addressCity = (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") ? 
    		COSTCO.CAddressForm.matchCityOption(form.find(`[name=${prefix}city]`), address.city) : address.city;
      
      form.find(`[name=${prefix}city]`).val(addressCity);
      form.find(`select[name=${prefix}state]`).val(address.state);
      form.find(`input[name=${prefix}postalcode],input[name=${prefix}zip]`).val(address.zip);
      form.find(`input[name=${prefix}country]`).val(address.country);
    },

    /*
     * Build Address Array for AVS from a query selector.
     * Based on address type it gets data from shipping/billing form section using prefixes shipping_/billing_
     */
    buildAVSAddressArray : function() {
      let shippingAddress = QuickRenewAddressHelper.buildAddressObjByType('S');
      let billingAddress = QuickRenewAddressHelper.buildAddressObjByType('B');

      let addressArray = [];
      if (QuickRenewAddressHelper.isAddressNotEmpty(shippingAddress)) {
        addressArray.push(shippingAddress);
      }

      if (QuickRenewAddressHelper.isAddressNotEmpty(billingAddress)) {
        addressArray.push(billingAddress);
      }

      $.each(addressArray, function (index, value) {
        if (value.id == '') {
          addressArray[index].id = index;
        }
      });

      return addressArray;
    },

    /**
     * Build a clean address object by stripping shipping_/billing_ prefixes from address input form elements.
     * New address object will be passed to AVS service who only understand clean field names.
     * @param {string} type Address type. Defaults to 'S', otherwise it can accpet 'B' as well
     */
    buildAddressObjByType : function(type) {
      let addressObject = {};
      let _baseAddr = $('#quick-renew-address-form');

      let addressPrefix = 'shipping_';
      let label = 'Shipping Address';
      if (type == 'B') {
        addressPrefix = 'billing_';
        label = 'Billing Address';
      }

      addressObject['id'] = _baseAddr.find(`[name=${addressPrefix}addressId]`).val() ? _baseAddr.find(`[name=${addressPrefix}addressId]`).val() : '';
      addressObject['fName'] = _baseAddr.find(`#${addressPrefix}firstId`).val();
      addressObject['lName'] = _baseAddr.find(`#${addressPrefix}lastId`).val();
      addressObject['company'] = _baseAddr.find(`[name=${addressPrefix}company]`).val();
      addressObject['country'] = _baseAddr.find(`[name=${addressPrefix}country]`).val();
      addressObject['line1'] = _baseAddr.find(`[name=${addressPrefix}address1]`).val();
      addressObject['line2'] = _baseAddr.find(`[name=${addressPrefix}address2]`).val();
      addressObject['zip'] = _baseAddr.find(`[name=${addressPrefix}postal]`).val();
      addressObject['city'] = _baseAddr.find(`[name=${addressPrefix}city]`).val();
      addressObject['state'] = _baseAddr.find(`[name=${addressPrefix}state]`).val();

      let pNumber = _baseAddr.find(`[name=${addressPrefix}phone]`);
      if (pNumber.length > 0) {
        addressObject['pNumber'] = pNumber.cleanVal();
      }

      addressObject['nickname'] = _baseAddr.find(`[name=${addressPrefix}nickname]`).val();
      addressObject['email'] = _baseAddr.find(`[name=${addressPrefix}email]`).val();
      addressObject['mInitial'] = _baseAddr.find(`[name=${addressPrefix}mInitial]`).val();
      addressObject['addressType'] = type;
      addressObject['label'] = label;
      addressObject['setDefault'] = _baseAddr.find(`[name=${addressPrefix}set_default]`).prop('checked');

      return addressObject;
    },

    /**
     * Checks if address object is not empty. It is enough to verify if first name is not present.
     */
    isAddressNotEmpty : function(addressObj) {
      if (addressObj && addressObj.fName && addressObj.fName.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * Transofrms address JSON obj to format accepted by QuickRenewManageAddressHandler.
     * This assumes that depending on the address type S/B we have to append specific prefix to
     * each of the JSON names e.g. for address type 'S' change 'fName' to 'shipping_fName'
     */
    transormAddressObj : function(origAddress) {

      let addressPrefix = 'shipping_';
      if (origAddress.addressType == 'B') {
        addressPrefix = 'billing_';
      }

      let transformed = {};

      transformed[`${addressPrefix}id`] = origAddress.id;
      transformed[`${addressPrefix}fName`] = origAddress.fName;
      transformed[`${addressPrefix}lName`] = origAddress.lName;
      transformed[`${addressPrefix}company`] = origAddress.company;
      transformed[`${addressPrefix}country`] = origAddress.country;
      transformed[`${addressPrefix}line1`] = origAddress.line1;
      transformed[`${addressPrefix}line2`] = origAddress.line2;
      transformed[`${addressPrefix}zip`] = origAddress.zip;
      transformed[`${addressPrefix}city`] = origAddress.city;
      transformed[`${addressPrefix}state`] = origAddress.state;
      transformed[`${addressPrefix}pNumber`] = origAddress.pNumber;
      transformed[`${addressPrefix}nickname`] = origAddress.nickname;
      transformed[`${addressPrefix}email`] = origAddress.email;
      transformed[`${addressPrefix}mInitial`] = origAddress.mInitial;
      transformed[`${addressPrefix}addressType`] = origAddress.addressType;
      transformed[`${addressPrefix}setDefault`] = origAddress.setDefault;

      return transformed;
    },

    /**
     * Creates inline address form.
     * @return {void}
     */
    createInlineAddressForm : function(shippingAddressId, billingAddressId) {

      let addressType = 'S';

      let template = COSTCO.util.tmpl('tmpl_quick_renew_address_form', {});
      template = $(template);

      let shippingTemplate = COSTCO.util.tmpl('tmpl_quick_renew_address_form_shipping_data', {});
      shippingTemplate = $(shippingTemplate);

      QuickRenewAddressHelper.populateCountryState(shippingTemplate, addressType);
      QuickRenewAddressHelper.bindZipCodeChangeEvents(shippingTemplate, addressType);
      
      shippingTemplate.find('#use-different-address-for-billing').click(function() {
      let showBillingAddress = false;
        if($(this).prop('checked')){
          showBillingAddress = true;
        }
        QuickRenewAddressHelper.showBillingAddressForm(template, showBillingAddress, billingAddressId);
      });

      QuickRenewAddressHelper.populateAddress(shippingTemplate,shippingAddressId);
      
      QuickRenewAddressHelper.maskAddressInputs(shippingTemplate, addressType);
      
      template.find('#quick-renew-shipping-data').html(shippingTemplate);

      $('#address-block-shipping-billing').html(template);
      
      addressArrayForAVS = QuickRenewAddressHelper.buildAVSAddressArray();
      
      QuickRenewAddressHelper.displayCityState(template,'shipping_');
    },

    /**
     * Show/hide billing address form section.
     * @param {object} template
     * @param {boolean} show
     * @return {void}
     */
    showBillingAddressForm : function(template, show, billingAddressId) {
      if (show) {

        let addressType = 'B';

        let billingTemplate = COSTCO.util.tmpl('tmpl_quick_renew_address_form_billing_data', {});
        billingTemplate = $(billingTemplate);

        QuickRenewAddressHelper.populateCountryState(billingTemplate, addressType);
        
        QuickRenewAddressHelper.bindZipCodeChangeEvents(billingTemplate, addressType);

        QuickRenewAddressHelper.populateAddress(billingTemplate, billingAddressId);
        QuickRenewAddressHelper.maskAddressInputs(billingTemplate, addressType);
        
        template.find('#quick-renew-billing-data').html(billingTemplate);
        let billingAddress = QuickRenewAddressHelper.buildAddressObjByType('B');
        addressArrayForAVS.push(billingAddress);
      } else {
        $(template.find('#quick-renew-billing-data')).empty();
        if(addressArrayForAVS.length > 1) {
        	addressArrayForAVS.pop();
        }
      }
      
      QuickRenewAddressHelper.handleDefaultAddressCheckboxes(show);
      QuickRenewAddressHelper.displayCityState(template,'billing_');
    },

    /**
     * Populates country/state.
     * @param {object} template
     * @param {string} addressType
     * @return {void}
     */
    populateCountryState : function(template, addressType) {
    
    	var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED
		&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
		let stateProvList = COSTCO.CAddress.getStateProvJson();
		let stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, addressType);
		
    	if(!isDeriveCityStateEnabled){
    		template.find('.stateprov-select').append(stateOptions);
    	}
      
      let countryOptions = COSTCO.CAddressForm.getCountryOptions(addressType);
      
      template.find('.country-select').append(countryOptions).change(function(){
            let country = $(this).val();
            let stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList,addressType,{country:country});
            if(!isDeriveCityStateEnabled){
              template.find('.stateprov-select').empty().append(stateOptions);
            }
            QuickRenewAddressHelper.updateCountryLabels(template, country, addressType);
            QuickRenewAddressHelper.maskAddressInputs(template, addressType);
      });
    },
    
    /**
     * Update labels depending on selected country.
     * 
     * @param {object} template
     * @param {string} country
     * @param {string} addressType
     * @return {void}
     */
    updateCountryLabels : function(template, country, addressType) {
      let addressTypePrefix = 'shipping_';
      if (addressType === 'B') {
        addressTypePrefix = 'billing_';
      }
        
  		if (country == 'US') {
  			template.find('label[for="' + addressTypePrefix + 'postalId"]').html(addressInputLabels.uspostallabel);
  			template.find('label[for="' + addressTypePrefix + 'stateId"]').html(addressInputLabels.usstatelabel);
  		} else {
  			template.find('label[for="' + addressTypePrefix + 'postalId"]').html(addressInputLabels.capostallabel);
  			template.find('label[for="' + addressTypePrefix + 'stateId"]').html(addressInputLabels.castatelabel);
  		}
  	},
    
    /**
     * Populates address.
     * @param {string} addresId
     * @return {void}
     */
    populateAddress : function(template, addressId) {
      let address = window['ajaxAddressObject_' + addressId];
      let addressPrefix = 'shipping_';
      if (address && address.addressType === 'B') {
        addressPrefix = 'billing_';
      }
      
      if(address){
        $(template).find('#' + addressPrefix + 'addressId').val(address.id);
        $(template).find('#' + addressPrefix + 'firstId').val(address.first);
        $(template).find('#' + addressPrefix + 'lastId').val(address.last);
        $(template).find('#' + addressPrefix + 'companyId').val(address.company);
        $(template).find('#' + addressPrefix + 'countryId').val(address.country);
        $(template).find('#' + addressPrefix + 'address1Id').val(address.line1);
        $(template).find('#' + addressPrefix + 'address2Id').val(address.line2);
        $(template).find('#' + addressPrefix + 'postalId').val(address.zip);
        
        if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
				&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
        	var savedAddrCity = address.city;
        	var savedAddrState = address.state;
        	if(savedAddrCity && savedAddrState){
        		COSTCO.CAddress.geocodeApiCityState($(template).find('#' + addressPrefix + 'postalId'),'[name='+addressPrefix + 'city]','[name='+ addressPrefix + 'state]', savedAddrCity, savedAddrState);
        	}
        } else {
        	$(template).find('#' + addressPrefix + 'cityId').val(address.city);
        	$(template).find('#' + addressPrefix + 'stateId').val(address.state);
        }
        
        $(template).find('#' + addressPrefix + 'phoneId').val(address.phone);
        $(template).find('#' + addressPrefix + 'nickname').val(address.nickname);
        $(template).find('#' + addressPrefix + 'emailId').val(address.email);
        $(template).find('#' + addressPrefix + 'mInitial').val(address.mInitial);
        $(template).find('#' + addressPrefix + 'addressType').val(address.addressType);
      }
    },

    /**
     * Uses Jquery Mask plugin to format input.
     * Use cleanVal() instead of val() to get unformatted value
     * @param {object} template
     * @param {string} addressType
     * @return {void}
     */
    maskAddressInputs : function(template, addressType) {

      let addressTypePrefix = 'shipping_';
      if (addressType === 'B') {
        addressTypePrefix = 'billing_';
      }

      $(template).find('#' + addressTypePrefix + 'phoneId').unmask().mask('000-000-0000');
      $(template).find('#' + addressTypePrefix + 'contactPhNo').unmask().mask('000-000-0000');

      if(QuickRenewAddressHelper.isUS(addressTypePrefix)){
        $(template).find('#' + addressTypePrefix + 'postalId').unmask().mask('00000-0000');
      }else{
        $(template).find('#' + addressTypePrefix + 'postalId').unmask().mask('S0S 0S0');
      }
    },
    
    /**
     * check is selected country US
     * 
     * @param {string} addressTypePrefix
     *  
     */
    isUS : function(addressTypePrefix){
    	let form = $('#quick-renew-address-form');

    	var country = 'US';

    	if($(form).find('[name=' + addressTypePrefix + 'country]').val() != 'undefined' && $(form).find('[name=' + addressTypePrefix + 'country]').val() != null){
    		country = $(form).find('[name=' + addressTypePrefix + 'country]').val();
    	}else{
    		if (COSTCO.util.getLangId() != -1){
    			country = 'CA';
    		}
    	}
    	return (country == 'US');
    },

    /**
     * Binds ZIP code change events.
     * @param {object} template
     * @param {string} addressType
     * @return {void}
     */
    bindZipCodeChangeEvents : function(template, addressType) {
      let addressTypePrefix = 'shipping_';
      if (addressType === 'B') {
        addressTypePrefix = 'billing_';
      }

      template.find('[name=' + addressTypePrefix + 'postal]').on('input', function(event) {
        var value = $(this).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			COSTCO.CAddress.bingCityState(this,'[name=' + addressTypePrefix + 'city]','[name=' + addressTypePrefix + 'state]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				COSTCO.CAddress.geocodeApiCityState(this,'[name=' + addressTypePrefix + 'city]','[name=' + addressTypePrefix + 'state]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				COSTCO.CAddress.geocodeApiCityState(this,'[name=' + addressTypePrefix + 'city]','[name=' + addressTypePrefix + 'state]');
			}
		}
		
		QuickRenewAddressHelper.displayCityState(template,addressTypePrefix);
		
      });
    },
    
    /**
     * Handles default address checkboxes: states and labels
     * @param {boolean} billingAddressFormDisplayed 
     */
    handleDefaultAddressCheckboxes : function(billingAddressFormDisplayed) {
      if(billingAddressFormDisplayed) {
    	$('#shipping_set_default_span').text(addressInputLabels.setDefaultShipping);
    	$('#billing_set_default_span').text(addressInputLabels.setDefaultBilling);
    	$('#billing_set_default').prop('checked', $('#shipping_set_default').prop('checked'));
      } else {
    	$('#shipping_set_default_span').text(addressInputLabels.setDefaultShippingAndBilling);
      }
    },
    
    /**
     * Displays the City and State fields after the default address data has been populated
     */
    displayCityState : function(template,addressTypePrefix) {
       if(template.find('#'+ addressTypePrefix +'postalId') != undefined && template.find('#'+ addressTypePrefix +'postalId').val() != ''){
          template.find('#'+ addressTypePrefix +'city-state').removeClass('hide');
       }
    },    
    
    /**
     * Opens default address change modal
     */
    openDefaultAddressChangeInfoModal : function(onConfirmCallback) {
	    COSTCO.dialog.createExtDialogBox({
	      title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	      body: $('#tmpl_quick_renew_default_address_info_dialog').html(),
	      primary: messages.JS_DIALOG_ACCEPT,
	      primary_event: function() { COSTCO.QuickRenewAddressHelper.submitAddress(onConfirmCallback) },
	      secondary: messages.JS_DIALOG_CANCEL
	    });	
    },
    
    /**
     */
    configureAddressesSectionBasedOnPaymentType: function(billingType) {
    	
    	if(COSTCO.MembershipHelper.isQuickMembership) {
    		let quickRenew = $('#quick-renew-address-section').length > 0 ? true : false;
        	
        	if(quickRenew) {
        		if(billingType == 'wallet') {
        			$('#quick-renew-address-section h4')[0].innerText = 'Shipping Address';
        			$('#use-different-address-for-billing').closest('.address-checkboxes').hide();
        			$('#shipping_set_default_span').text(addressInputLabels.setDefaultShipping);
        			$('#quick-renew-billing-data').hide();
        		} else {
        			$('#quick-renew-address-section h4')[0].innerText = 'Shipping and Billing Address';
        			$('#use-different-address-for-billing').closest('.address-checkboxes').show();
        			$('#shipping_set_default_span').text(addressInputLabels.setDefaultShippingAndBilling);
        			$('#quick-renew-billing-data').show();
        		}
        	} else {
        		if(billingType == 'wallet') {
        			$('#address-block-billing').parent().hide();
        		} else {
        			$('#address-block-billing').parent().show();
        		}
        	}
    	}
    }
  }

  if (typeof window.COSTCO === "undefined") {
    window.COSTCO = new Object();
  } 

  window.COSTCO.QuickRenewAddressHelper = QuickRenewAddressHelper;

  return QuickRenewAddressHelper;
});



// WEBPACK FOOTER //
// ./js/membership/quick-renew-address-helper.js